import api from '../api';

const employmentHistoryService = {
  // Get employment history for a specific guardian
  getByGuardianId: async (guardianId) => {
    try {
      const response = await api.get(`/employmenthistory/guardian/${guardianId}`);
      return response.data.data; // Extract data from { status: 'success', data: [...] }
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch employment history');
    }
  },

  // Get a specific employment history record
  getById: async (id) => {
    try {
      const response = await api.get(`/employmenthistory/${id}`);
      return response.data.data; // Extract data from { status: 'success', data: {...} }
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch employment history record');
    }
  },

  // Create new employment history record
  create: async (employmentData) => {
    try {
      const response = await api.post('/employmenthistory', employmentData);
      return response.data.data; // Extract data from { status: 'success', data: {...} }
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create employment history');
    }
  },

  // Update employment history record
  update: async (id, employmentData) => {
    try {
      const response = await api.put(`/employmenthistory/${id}`, employmentData);
      return response.data.data; // Extract data from { status: 'success', data: {...} }
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update employment history');
    }
  },

  // Delete employment history record
  delete: async (id) => {
    try {
      const response = await api.delete(`/employmenthistory/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete employment history');
    }
  },
};

export default employmentHistoryService;
